// Copied from Vimeo's TS Typings document
// Ideally this would be exported from their component

export enum ELanguage {
  DE = 'de-DE',
  EN = 'en',
  ES = 'es',
  FR = 'fr-FR',
  JP = 'ja-JP',
  BR = 'pt-BR',
  KR = 'ko-KR'
}
export enum EVimeoRecordWidgetEvent {
  SDK_STATE_EVENT = 'sdkstatechange',
  VIDEO_STATE_EVENT = 'videostatechange',
  ANALYTICS = 'analytics'
}
export enum EVideoState {
  VIDEO_UPLOADED = 'videoUploaded',
  VIDEO_READY = 'videoReady',
  VIDEO_ADD = 'videoAdd',
  VIDEO_DISCARD = 'videoDiscard'
}
export enum EVimeoRecordWidgetButton {
  ADD_VIDEO = 'addVideo',
  DISCARD_VIDEO = 'discardVideo'
}
export type TRecordTheme = {
  fonts?: {
    importRules?: string;
    title?: string;
    headline?: string;
    subhead?: string;
    body?: string;
    meta?: string;
    button?: string;
    input?: string;
  };
  icons?: {
    audioOff?: string;
    audioOn?: string;
    cameraOff?: string;
    cameraOn?: string;
    checkMark?: string;
    chevronDown?: string;
    circleError?: string;
    circleInfo?: string;
    circlePlus?: string;
    deviceError?: string;
    dismissX?: string;
    dismissXSmall?: string;
    download?: string;
    entireScreen?: string;
    extensions?: string;
    flip?: string;
    folder?: string;
    link?: string;
    loader?: string;
    micOff?: string;
    micOn?: string;
    modeBoth?: string;
    modeCamera?: string;
    modeScreen?: string;
    privacyOnlyMe?: string;
    privacyPassword?: string;
    privacyPrivateLink?: string;
    privacyPublic?: string;
    recordingPause?: string;
    recordingResume?: string;
    recordingStart?: string;
    recordingStop?: string;
    recordingStartButton?: string;
    retry?: string;
    settings?: string;
    thumbsUp?: string;
    trash?: string;
    connectionLine?: string;
    // recordingCancel NOT INCLUDED IN ORIGINAL DOCS
    recordingCancel?: string;
  };
  colors?: {
    $audioWaves_colorA?: string;
    $audioWaves_colorB?: string;
    $common_boxShadow_default?: string;
    $common_overlay_postRecord?: string;
    $common_overlay_preRecord?: string;
    $divider_color_default?: string;
    $content_background_default?: string;
    $content_background_inversed?: string;
    $content_color_default?: string;
    $content_color_inactive?: string;
    $content_color_inversed?: string;
    $popup_background_default?: string;
    $popup_color_default?: string;
    $input_background_default?: string;
    $input_background_disabled?: string;
    $input_border_default?: string;
    $input_border_focus?: string;
    $input_border_hover?: string;
    $input_color_default?: string;
    $input_color_placeholder?: string;
    $item_background_hover?: string;
    $item_color_accent_default?: string;
    $item_color_accent_hover?: string;
    $notice_background_error?: string;
    $notice_background_info?: string;
    $notice_background_upsell?: string;
    $notice_color_error?: string;
    $notice_color_info?: string;
    $notice_color_upsell?: string;
    $preview_background_default?: string;
    $recordingMode_background_selected?: string;
    $buttonPrimary_background_default?: string;
    $buttonPrimary_background_hover?: string;
    $buttonPrimary_background_active?: string;
    $buttonPrimary_background_disabled?: string;
    $buttonPrimary_border_default?: string;
    $buttonPrimary_border_hover?: string;
    $buttonPrimary_border_active?: string;
    $buttonPrimary_border_disabled?: string;
    $buttonPrimary_color_default?: string;
    $buttonPrimary_color_hover?: string;
    $buttonPrimary_color_active?: string;
    $buttonPrimary_color_disabled?: string;
    $buttonSecondary_background_default?: string;
    $buttonSecondary_background_hover?: string;
    $buttonSecondary_background_active?: string;
    $buttonSecondary_background_disabled?: string;
    $buttonSecondary_border_default?: string;
    $buttonSecondary_border_hover?: string;
    $buttonSecondary_border_active?: string;
    $buttonSecondary_border_disabled?: string;
    $buttonSecondary_color_default?: string;
    $buttonSecondary_color_hover?: string;
    $buttonSecondary_color_active?: string;
    $buttonSecondary_color_disabled?: string;
    $buttonDanger_background_default?: string;
    $buttonDanger_background_hover?: string;
    $buttonDanger_background_active?: string;
    $buttonDanger_background_disabled?: string;
    $buttonDanger_border_default?: string;
    $buttonDanger_border_hover?: string;
    $buttonDanger_border_active?: string;
    $buttonDanger_border_disabled?: string;
    $buttonDanger_color_default?: string;
    $buttonDanger_color_hover?: string;
    $buttonDanger_color_active?: string;
    $buttonDanger_color_disabled?: string;
    $buttonOptional_background_default?: string;
    $buttonOptional_background_hover?: string;
    $buttonOptional_background_active?: string;
    $buttonOptional_background_disabled?: string;
    $buttonOptional_border_default?: string;
    $buttonOptional_border_hover?: string;
    $buttonOptional_border_active?: string;
    $buttonOptional_border_disabled?: string;
    $buttonOptional_color_default?: string;
    $buttonOptional_color_hover?: string;
    $buttonOptional_color_active?: string;
    $buttonOptional_color_disabled?: string;
  };
  borderRadii?: {
    window?: string;
    button?: string;
    pillButton?: string;
    input?: string;
    tooltip?: string;
    preview?: string;
    recordingMode?: string;
  };
};
export enum EShareFooterButton {
  ADD_VIDEO = 'addVideo',
  DISCARD_VIDEO = 'discardVideo',
  COPY_LINK = 'copyLink',
  VIEW_ON_VIMEO = 'viewOnVimeo'
}
export type TButtonFormat = 'primary' | 'secondary' | 'danger' | 'optional' | 'icon';
interface IShareFooterButton {
  type: EShareFooterButton;
  format: TButtonFormat;
}
export type TCustomNotification = {
  message: string;
  format?: 'error' | 'info';
};
export type TVimeoRecordWidgetConfiguration = {
  accessToken: string;
  partnerTitle: string;
  partnerLogoURL: string;
  connectAccountURL: string;
  teamOwnerUri?: string;
  rootElement?: HTMLElement;
  connectAccountIllustration?: string;
  customization?: TRecordTheme;
  language?: ELanguage;
  defaultVideoTitle?: string;
  defaultVideoDescription?: string;
  activationSource?: string;
  partnerDomain?: string;
  partnerUserId?: string | null;
  customShareActions?: {
    settings?: boolean;
    download?: boolean;
    delete?: boolean;
    footer?: 'copyLinkURL' | Array<IShareFooterButton>;
  };
  customNotifications?: {
    preRecording?: TCustomNotification;
    postRecording?: TCustomNotification;
  };
};

export type TVimeoRecordWidgetConfigurationChangeable = {
  accessToken?: string;
  partnerTitle?: string;
  partnerLogoURL?: string;
  connectAccountURL?: string;
  teamOwnerUri?: string;
  connectAccountIllustration?: string;
  customization?: TRecordTheme;
  language?: ELanguage;
  defaultVideoTitle?: string;
  defaultVideoDescription?: string;
  activationSource?: string;
  partnerDomain?: string;
  partnerUserId?: string | null;
  customShareActions?: {
    settings?: boolean;
    download?: boolean;
    delete?: boolean;
    footer?: 'copyLinkURL' | Array<IShareFooterButton>;
  };
  customNotifications?: {
    preRecording?: TCustomNotification;
    postRecording?: TCustomNotification;
  };
};
export type TThumbnail = {
  width: number;
  height: number;
  link: string;
  link_with_play_button: string;
};
export type TVideoReady = {
  url: string;
  id: number;
  name: string;
  description: string;
  videoReady: boolean;
  videoAdd: boolean;
  duration: number;
  width: number;
  height: number;
  thumbnail: Array<TThumbnail>;
};
export type TAnalyticsEventName =
  | 'shareAddVideoClicked'
  | 'shareDiscardVideoClicked'
  | 'connectAccountsShareClicked'
  | 'connectAccountsBannerClicked'
  | 'connectAccountsBannerShown'
  | 'connectAccountsShareShown'
  | 'pipOpened'
  | 'pipClosed'
  | 'recordingStartClicked'
  | 'recordingPauseClicked'
  | 'recordingResumeClicked'
  | 'recordingStopClicked'
  | 'countdownCancelButtonClicked'
  | 'cancelButtonClicked'
  | 'cancelConfirmClicked'
  | 'cancelContinueClicked';
export type TSdkState = {
  isInitialized: boolean;
  isUIShown: boolean;
  isRecording: boolean;
  isManagedUser: boolean | undefined;
};
export type TAnalyticsCallback = (analyticsEventName: TAnalyticsEventName) => any;
export type TVideoStateCallback = (videoState: EVideoState, videoInfo?: TVideoReady) => any;
export type TSdkStateCallback = (state: TSdkState) => any;

export interface IVimeoRecordWidget {
  readonly isInitialized: boolean;
  readonly isUIShown: boolean;
  readonly isRecording: boolean;
  readonly isManagedUser: boolean | undefined;
  readonly isEnvironmentSupported: boolean;
  // configure the widget instance (create and init widget)
  initialize(configuration: TVimeoRecordWidgetConfiguration): Promise<void>;
  // re-configure the widget instance (will change widget configs on-the-fly)
  update(configuration: TVimeoRecordWidgetConfigurationChangeable): Promise<void>;
  // cleanup the widget instance (dismount, remove listeners, clear pointers, etc.)
  dispose(): void;
  // start (open the UI) the widget
  activate(): Promise<void>;
  // stop (close the UI) the widget
  deactivate(): void;
  // preload user info before activation to have UI ready for recording (be careful, as the user
  // data loaded with this method will persist until unloadUserInfo() is called
  preloadUserInfo(): Promise<void>;
  // unload user info to fetch user info again on every activation
  unloadUserInfo(): void;
  // set the disabled state for one of the buttons
  setButtonDisabled(buttonName: EVimeoRecordWidgetButton, state: boolean): Promise<void>;
  // get all of the widget's logs
  getLogs(): Promise<Array<any>>;
  // 'ON' events: callbacks registered here will invoked each time event occurs
  on(eventName: `${EVimeoRecordWidgetEvent.SDK_STATE_EVENT}`, callback: TSdkStateCallback): void;
  on(eventName: `${EVimeoRecordWidgetEvent.VIDEO_STATE_EVENT}`, callback: TVideoStateCallback): void;
  on(eventName: `${EVimeoRecordWidgetEvent.ANALYTICS}`, callback: TAnalyticsCallback): void;
  // 'ONCE' events: same as ON, but callback will be taken off after it's first invocation
  once(eventName: `${EVimeoRecordWidgetEvent.SDK_STATE_EVENT}`, callback: TSdkStateCallback): void;
  once(eventName: `${EVimeoRecordWidgetEvent.VIDEO_STATE_EVENT}`, callback: TVideoStateCallback): void;
  once(eventName: `${EVimeoRecordWidgetEvent.ANALYTICS}`, callback: TAnalyticsCallback): void;
  // 'OFF' events: remove callbacks registered with ON/ONCE
  off(eventName: `${EVimeoRecordWidgetEvent.SDK_STATE_EVENT}`, callback: TSdkStateCallback): void;
  off(eventName: `${EVimeoRecordWidgetEvent.VIDEO_STATE_EVENT}`, callback: TVideoStateCallback): void;
  off(eventName: `${EVimeoRecordWidgetEvent.ANALYTICS}`, callback: TAnalyticsCallback): void;
}
